/* eslint-disable eslint-comments/disable-enable-pair, multiline-ternary, react/jsx-no-literals, react/no-set-state */
import React, { PureComponent } from 'react';
import IntersectionObserver from '@researchgate/react-intersection-observer';
import PropTypes from 'prop-types';

import Domain from '@mdi/svg/svg/domain.svg';

import styles from 'src/components/Tile/TileImage.scss';


class TileImage extends PureComponent {
  state = { shouldLoadImage: false };

  observerCallback = ({ isIntersecting }, unobserve) => requestIdleCallback(() => {
    if (isIntersecting) {
      this.setState(() => ({ shouldLoadImage: true }));
      unobserve();
    }
  });

  render() {
    const { source, alt } = this.props;
    const noImageClasses = `${styles.placeholder}`;
    const { shouldLoadImage } = this.state;
    if (!source) {
      return <Domain className={ noImageClasses } viewBox="0 0 24 24" />;
    }
    const { observerCallback } = this;
    return (
      <IntersectionObserver onChange={ observerCallback } rootMargin="100px">
        <div className={ styles.logo }>
          { shouldLoadImage
            ? (
              <img
                alt={ alt }
                className={ styles.logo__image }
                src={ source }
                width="65"
                height="65"
                srcSet={ `${source}?width=65&height=65 1x, ${source}?width=130&height=130 2x` }
              />
            ) : <Domain className={ noImageClasses } viewBox="0 0 24 24" />
          }
        </div>
      </IntersectionObserver>
    );
  }
}

TileImage.propTypes = {
  alt: PropTypes.string.isRequired,
  source: PropTypes.string
};

TileImage.defaultProps = {
  source: ''
};

export default TileImage;
